import type { ThemeProviderProps as MuiThemeProviderProps, Theme } from '@mui/material/styles';
import type {} from './extend-theme-types';
import type { ThemeOptions } from './types';

import CssBaseline from '@mui/material/CssBaseline';
import { ThemeProvider as ThemeVarsProvider } from '@mui/material/styles';
import { ThemeProvider as StyledThemeProvider } from 'styled-components';

// import { useTranslate } from 'src/locales';

import { useMemo } from 'react';
import { useSettingsContext } from '../../contexts/settings/use-settings-context';
import { createTheme } from './create-theme';

import Light from '../../themes/light';

// ----------------------------------------------------------------------

export type ThemeProviderProps = Partial<MuiThemeProviderProps<Theme>> & {
  themeOverrides?: ThemeOptions;
};

export function ThemeProvider({ themeOverrides, children, ...other }: ThemeProviderProps) {
  const settings = useSettingsContext();
  // const { currentLang } = useTranslate();

  const theme = useMemo(
    () =>
      createTheme({
        settingsState: settings.state,
        // localeComponents: currentLang?.systemValue,
        themeOverrides
      }),
    [settings.state, themeOverrides]
  );

  return (
    <ThemeVarsProvider disableTransitionOnChange theme={theme} {...other}>
      <StyledThemeProvider theme={Light}>
        <CssBaseline />
        {/* <Rtl direction={settings.state.direction}> */}
        {children}
        {/* </Rtl> */}
      </StyledThemeProvider>
    </ThemeVarsProvider>
  );
}
